var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Developing'),_c('Discover'),_c('Carousel'),_c('StringsForEduc'),_c('StringsForBs'),_c('StringsForTest'),_c('StringsForCom'),_c('StringsForComp'),_c('GsAssist'),_c('OurPartners'),_c('Book')],1)}
var staticRenderFns = []

export { render, staticRenderFns }